"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const styles = (0, _makeStyles.default)(theme => ({
  form: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1.5),
    width: "100%",
    "& input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active": {
      transition: "background-color 5000s ease-in-out 0s"
    },
    [theme.breakpoints.up("sm")]: {
      "& .mco-form-select": {
        flex: `0 0 calc(50% - ${theme.spacing(0.75)}px)`
      },
      "& .mco-form-input:not(.mco-form-textarea):not(.mco-form-file)": {
        flex: `0 0 calc(50% - ${theme.spacing(0.75)}px)`
      },
      "& .mco-form-date": {
        flex: `0 0 calc(50% - ${theme.spacing(0.75)}px)`
      },
      "& .mco-form-multiple-checkbox": {
        flex: `0 0 calc(50% - ${theme.spacing(0.75)}px)`
      }
    }
  }
}));
var _default = exports.default = styles;